'use strict';

var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require('function-bind');

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);



//////////////////
// WEBPACK FOOTER
// /Users/manskow/Local Sites/topphndball-v-53/app/public/wp-content/themes/nth-5.3/node_modules/hasown/index.js
// module id = 43
// module chunks = 0